import React, { useState, useEffect } from 'react';
import { Menu, X, Scissors, Phone, Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { barbershopInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-slate-950/95 backdrop-blur-md shadow-lg shadow-slate-900/50'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="relative">
              <div className="w-12 h-12 border-2 border-[#c9a962] flex items-center justify-center">
                <span className="text-[#c9a962] font-bold text-xl tracking-wider">NY</span>
              </div>
              <Scissors className="absolute -top-2 -right-2 w-4 h-4 text-[#c9a962] rotate-45" />
            </div>
            <div className="hidden sm:block">
              <p className="text-[#c9a962] text-xs tracking-[0.3em] uppercase">Barbershop</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" dir="rtl">
            <button
              onClick={() => scrollToSection('about')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors duration-300 text-sm tracking-wide"
            >
              אודות
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors duration-300 text-sm tracking-wide"
            >
              שירותים
            </button>
            <button
              onClick={() => scrollToSection('barbers')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors duration-300 text-sm tracking-wide"
            >
              הספרים שלנו
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors duration-300 text-sm tracking-wide"
            >
              גלריה
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors duration-300 text-sm tracking-wide"
            >
              צור קשר
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href={barbershopInfo.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-[#c9a962] hover:bg-[#b8962f] text-slate-950 font-semibold px-6 py-2 transition-all duration-300 hover:shadow-lg hover:shadow-[#c9a962]/25">
                <Calendar className="w-4 h-4 ml-2" />
                הזמן תור
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-slate-300 hover:text-[#c9a962] transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-500 ${
            isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="py-4 flex flex-col gap-4 border-t border-slate-800" dir="rtl">
            <button
              onClick={() => scrollToSection('about')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors text-right py-2"
            >
              אודות
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors text-right py-2"
            >
              שירותים
            </button>
            <button
              onClick={() => scrollToSection('barbers')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors text-right py-2"
            >
              הספרים שלנו
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors text-right py-2"
            >
              גלריה
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-slate-300 hover:text-[#c9a962] transition-colors text-right py-2"
            >
              צור קשר
            </button>
            <a
              href={barbershopInfo.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2"
            >
              <Button className="w-full bg-[#c9a962] hover:bg-[#b8962f] text-slate-950 font-semibold">
                <Calendar className="w-4 h-4 ml-2" />
                הזמן תור
              </Button>
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
